import React from 'react';
import classNames from 'classnames';

import { NotStartedBanner } from './NotStartedBanner';
import { InProgressBanner } from './InProgressBanner';
import cn from './styles.module.scss';

export { SurveySeasonBadge } from './SurveySeasonBadge';
export { SurveySeasonIllustration } from './SurveySeasonIllustration';
export { ClipboardCheckIcon } from './ClipboardCheckIcon';

export const SurveySeasonStatus = {
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
} as const;

export type SurveySeasonStatus = typeof SurveySeasonStatus[keyof typeof SurveySeasonStatus];

type CommonProps = {
  className?: string;
  onAction?: () => void;
  onClose?: () => void;
};

type SurveySeasonBannerProps = CommonProps & (
  | { status?: typeof SurveySeasonStatus.NotStarted; planName?: never }
  | { status: typeof SurveySeasonStatus.InProgress; planName: string }
);

export function SurveySeasonBanner(props: SurveySeasonBannerProps) {
  const { className, onAction, onClose } = props;
  const isInProgress = props.status === SurveySeasonStatus.InProgress;

  return (
    <div
      className={classNames(cn.banner, isInProgress && cn.bannerCompact, className)}
      data-testid="surveySeasonBanner"
      data-status={isInProgress ? SurveySeasonStatus.InProgress : SurveySeasonStatus.NotStarted}
    >
      {props.status === SurveySeasonStatus.InProgress ? (
        <InProgressBanner planName={props.planName} onContinue={onAction} onClose={onClose} />
      ) : (
        <NotStartedBanner onGetStarted={onAction} onClose={onClose} />
      )}
    </div>
  );
}
